import React from "react";
import { Box, Divider, Drawer, List, Typography, useMediaQuery, useTheme } from "@mui/material";
import { SideBarWidth } from "../../utils/SideBarWidth";
import SideBarItem from "../../Components/SideBarItem";
import { Colors } from "../../Theme/Theme";
import FiLogo from "../../Components/FiLogo";
import { SideBarItems, sideBarBottomItems } from "../../utils/SideBarMenuItems";
import { AdminSideBarMenuItems } from "../../utils/AdminSideBarMenuItems";

export default function Sidebar({ mobileOpen, handleDrawerToggle }) {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isAdmin = localStorage.getItem("Role") === "ADMIN";

  const [activeState, setActiveState] = React.useState(0);

  const mainItems = SideBarItems?.filter((_, i) => i === 0);
  const insuranceItems = SideBarItems?.filter(el => el.isInsurance);
  const financeItems = SideBarItems?.filter(el => el.isFinance);
  const operationItems = SideBarItems?.filter(el =>
    !el.isInsurance && !el.isFinance && !el.comingSoon && SideBarItems.indexOf(el) > 0
  );

  const SectionLabel = ({ label }) => (
    <Typography sx={{
      px: 2.5, pt: 2.5, pb: 0.5, fontSize: "10px", fontWeight: 700,
      color: Colors.light_gray, letterSpacing: "1.2px", textTransform: "uppercase",
    }}>
      {label}
    </Typography>
  );

  const renderItem = (element, keyPrefix, index, allItems) => {
    const globalIndex = allItems ? allItems.indexOf(element) : index;
    return (
      <SideBarItem
        key={`${keyPrefix}-${index}`}
        Icon={element.Icon}
        title={element.title}
        url={element.path}
        active={activeState === `${keyPrefix}-${globalIndex}`}
        onClick={() => setActiveState(`${keyPrefix}-${globalIndex}`)}
        isInsurance={element.isInsurance}
        comingSoon={element.comingSoon}
        index={index}
      />
    );
  };

  const drawerContent = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {isMediumScreen && (
        <>
          <Box sx={{ px: 2, py: 2, display: "flex", alignItems: "center" }}>
            <FiLogo size="md" />
          </Box>
          <Divider sx={{ borderColor: Colors.dividerColor }} />
        </>
      )}
      <Box sx={{ flex: 1, overflowY: "auto", py: 1 }}>
        <List disablePadding>
          {mainItems?.map((element, index) => renderItem(element, "main", index, SideBarItems))}
        </List>

        {insuranceItems?.length > 0 && (
          <>
            <SectionLabel label="Insurance" />
            <List disablePadding>
              {insuranceItems.map((element, index) => renderItem(element, "ins", index, SideBarItems))}
            </List>
          </>
        )}

        {financeItems?.length > 0 && (
          <>
            <SectionLabel label="Finance" />
            <List disablePadding>
              {financeItems.map((element, index) => renderItem(element, "fin", index, SideBarItems))}
            </List>
          </>
        )}

        {operationItems?.length > 0 && (
          <>
            <SectionLabel label="Operations" />
            <List disablePadding>
              {operationItems.map((element, index) => renderItem(element, "ops", index, SideBarItems))}
            </List>
          </>
        )}

        {isAdmin && AdminSideBarMenuItems?.length > 0 && (
          <>
            <Box sx={{ mx: 1.5, my: 1 }}>
              <Divider sx={{ borderColor: Colors.dividerColor }} />
            </Box>
            <SectionLabel label="Admin Panel" />
            <List disablePadding>
              {AdminSideBarMenuItems.map((element, index) => renderItem(element, "admin", index, AdminSideBarMenuItems))}
            </List>
          </>
        )}
      </Box>

      <Divider sx={{ borderColor: Colors.dividerColor }} />
      <Box sx={{ py: 0.5 }}>
        <List disablePadding>
          {sideBarBottomItems?.map((element, index) => (
            <SideBarItem
              key={`bottom-${index}`}
              Icon={element.Icon}
              title={element.title}
              url={element.path}
              active={false}
              onClick={element.onClick}
              isInsurance={element.isInsurance}
              index={index + 100}
            />
          ))}
        </List>
      </Box>
    </Box>
  );

  const drawerSx = {
    width: SideBarWidth, flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: SideBarWidth, boxSizing: "border-box",
      backgroundColor: Colors.white, borderRight: `1px solid ${Colors.dividerColor}`,
      top: { xs: 0, md: "64px" }, height: { xs: "100%", md: "calc(100% - 64px)" },
    },
  };

  return (
    <Box component="nav" sx={{ width: { md: SideBarWidth }, flexShrink: { md: 0 } }}>
      <Drawer variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{ keepMounted: true }} sx={{ display: { xs: "block", md: "none" }, ...drawerSx }}>
        {drawerContent}
      </Drawer>
      <Drawer variant="permanent" sx={{ display: { xs: "none", md: "block" }, ...drawerSx }} open>
        {drawerContent}
      </Drawer>
    </Box>
  );
}
